// extracted by mini-css-extract-plugin
module.exports = {"tableRoot":"cXG0K","noData":"HBDcp"};